<template>
    <div class="VismaStatusWrapper">
      <div class="p-inputgroup">
        <Button iconPos="right" label="Visma" :disabled="syncing" :icon="buttonIcon" :class="buttonClass" @click="refresh" />
        <Button icon="pi pi-cog" :class="buttonClass" @click="display=true" :disabled="nbrConnected === 0" />
      </div>
      <Dialog header='Visma synkronisering' :modal="true" :visible.sync="display">
        <template #header>
          Visma Synkronisering
        </template>
        Synkronisera vismadata:
        <Button label="Kunder" :disabled="syncing" @click="onSyncronizeCustomers()" />
        <Button label="Artiklar" :disabled="syncing" @click="onSynchronizeArticles()" />
      </Dialog>
    </div>
</template>

<script>

import Button from 'primevue/button'
import Dialog from 'primevue/dialog'

export default {
  name: 'VismaStatus',
  components: {
    Button,
    Dialog
  },
  data () {
    return {
      display: false,
      nbrConnected: 0,
      interval: null,
      buttonIcon: 'pi pi-ban',
      buttonClass: 'p-button-danger',
      syncing: false,
      syncInterval: null
    }
  },
  async created () {
    await this.refresh()

    this.interval = setInterval(async () => {
      if (!this.syncing) {
        await this.refresh()
      }
    }, 1000 * 60 * 5)
  },
  beforeDestory () {
    clearInterval(this.interval)
  },
  methods: {
    setChecking () {
      this.buttonIcon = 'pi pi-spinner pi-spin'
      this.buttonClass = 'p-button-danger'
    },
    setOffline () {
      this.buttonIcon = 'pi pi-ban'
      this.buttonClass = 'p-button-danger'
    },
    setOnline () {
      this.buttonIcon = 'pi pi-check-circle'
      this.buttonClass = 'p-button-success'
    },
    setSyncing () {
      this.buttonIcon = 'pi pi-spinner pi-spin'
      this.buttonClass = 'p-button-success'
    },
    setSyncDone () {
      this.buttonIcon = 'pi pi-check-circle'
      this.buttonClass = 'p-button-success'
    },
    async getConnectionStatus () {
      try {
        const { data } = await this.$http.get('/api/vismasync/status')
        if (data.connected === undefined) {
          return 0
        }
        return data.connected
      } catch (err) {
        return 0
      }
    },
    async refresh () {
      this.syncing = true
      this.setChecking()
      this.nbrConnected = await this.getConnectionStatus()
      this.nbrConnected > 0 ? this.setOnline() : this.setOffline()
      this.syncing = false
    },
    pollStop () {
      clearInterval(this.syncInterval)
      this.setSyncDone()
      this.syncing = false
    },
    pollStatus (url) {
      clearInterval(this.syncInterval)
      this.syncInterval = setInterval(async () => {
        const { data } = await this.$http.get(url)
        if (data.status === 'notfound' || data.status === 'done') {
          return this.pollStop()
        }
      }, 1000)
    },
    async onSynchronizeArticles () {
      if (this.syncing) {
        return
      }
      this.setSyncing()
      const { data } = await this.$http.post('/api/vismasync/feralco-delivery', { articles: { sync: true } })
      this.pollStatus(data.requestStatus)
    },
    async onSynchronizeCustomers () {
      if (this.syncing) {
        return
      }
      this.setSyncing()
      const { data } = await this.$http.post('/api/vismasync/customers', { customers: { sync: true } })
      this.pollStatus(data.requestStatus)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menus/VismaStatus.vue